// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubMenuItem_wrapper__tsb7_","selectedItem":"SubMenuItem_selectedItem__3vyIM"};